import AxiosClient from "../../../services/axios.services";

class MatrizSucesionServices {
  getMatrizSucesion = (params) => {
    return AxiosClient.get("/api/app/carrera_sucesion_matriz_sucession/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  }

  saveSucesor = (data) =>
    AxiosClient.post(
      "/api/app/carrera_sucesion_cursos_titulares/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteSucesor = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_sucesion_cursos_titulares/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );


}

export default new MatrizSucesionServices();